//!Recuerda que un reducer solo es una funcion pura

import { types } from "../types/types";


/*
este sera mi estado si el usuario esta autentificado
    const state = {
    name: 'eury',
    logged: true,
}

*/


export const autReducer = (state = {}, action) => {

    switch (action.type) {
        case types.login:
            return {
                ...action.payload,
                logged: true,
            };

        case types.logout:
            return {};

        default:
            return state; //retorna el  state como se encunetre
    };
};

